import { Utils } from "@app-services/utils.service";
import { ContextType } from "@enums/context-type.enum";
import { getContextType } from "@session/session";

const traceBufferMaxSize = {
    [ContextType.Main]: 12288, // 12 KiB.
    [ContextType.TaskPane]: 4096, // 4 KiB.
};

const traceBufferTruncateSize = {
    [ContextType.Main]: 6144, // 6 KiB.
    [ContextType.TaskPane]: 2048, // 2 KiB.
};

let traceBuffer: string[] = [];

export function pushToTraceBuffer(trace: string) {
    traceBuffer.push(trace);
    truncateTraceBuffer();
}

export function addToTraceBuffer(traces: string[], idx: number) {
    if (idx < 0 || idx > traceBuffer.length) {
        throw Error(`Index ${idx} is out of range`);
    }

    const leftPart = traceBuffer.slice(0, idx);
    const rightPart = traceBuffer.slice(idx);

    traceBuffer = leftPart
        .concat(traces)
        .concat(rightPart);

    truncateTraceBuffer();
}

export function getTraceBuffer() {
    return traceBuffer;
}

export function clearTraceBuffer() {
    traceBuffer = [];
}

function truncateTraceBuffer() {
    // This implementation is optimized for speed, but it can be a bit inacurrate in some scenarios,
    // where traces contain non-unicode characters. Using new Blob(traceBuffer).size to get the size
    // could be more accurate, but also a bit slower.

    // Trace to console directly in this method, as we are trying to cleanup traces here.

    var traceBufferSize = Utils.getArraySizeBytes(traceBuffer);
    const contextTraceBufferMaxSize = traceBufferMaxSize[getContextType()];

    if (traceBufferSize < contextTraceBufferMaxSize) {
        return; // No need to truncate trace buffer yet.
    }

    console.debug(`Truncating trace buffer (size: ${traceBufferSize} B)`);
    const traceBufferTruncatedSize = traceBufferTruncateSize[getContextType()];

    for (var idx = 0; idx < traceBuffer.length && traceBufferSize > traceBufferTruncatedSize; idx++) {
        traceBufferSize -= Utils.getSizeBytes(traceBuffer[idx]);
    }

    traceBuffer = traceBuffer.slice(idx);
    console.debug(`Truncated trace buffer to ${traceBufferSize} B`);
}